module.exports = __webpack_public_path__ + "images/backgrounds/dew/medium.3c48521165d06a9ea046.jpg";